module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h1', {
    staticClass: "chapter-number---IVP sigil_not_in_toc"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page5",
      "title": "5"
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "chapter-title---IVP",
    attrs: {
      "id": "_idParaDest-3",
      "title": "Prelude: Promises"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor002"
    }
  }), _vm._v("Prelude")]), _vm._v(" "), _c('h3', {
    staticClass: "chapter-subtitle---IVP sigil_not_in_toc"
  }, [_vm._v("Promises")]), _vm._v(" "), _c('p', {
    staticClass: "veryfirst"
  }, [_c('span', {
    staticClass: "first-words"
  }, [_vm._v("Let’s make a deal, you and me. ")]), _vm._v("Let’s make promises to each other.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("I promise to tell you my story. The whole story. I’ll tell you about a boy in love with Jesus who, at the fateful onset of puberty, realized his sexual attractions were persistently and exclusively for other guys. I’ll tell you how I lay on my bed in the middle of the night and whispered to myself the words I’ve whispered a thousand times since:")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“I’m gay.”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("I’ll tell you how I cried and prayed and begged God to make me straight, or else to make me believe that the Bible left room for monogamous same-sex relationships. I’ll tell you how God kept refusing to do either one, how he kept pointing me back to the cross of Christ. How I followed my Savior in costly obedience and became a mythical creature, a thing that wasn’t supposed to exist: a single gay Christian.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("I’ll show you the world through my eyes: The books on Christian masculinity that never seemed to be about me. The churches that "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page6",
      "title": "6"
    }
  }), _vm._v("treated my singleness like an acne problem that could be cleared up with a few weeks’ treatment. The sincere Christians who called it “love” when they talked about people like me with revulsion in their voices.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("I’ll tell you what it’s like to belong nowhere. To know that much of my Christian family will forever consider me unnatural, dangerous, because of something that feels as involuntary as my eye color. And to know that much of the LGBTQ community that shares my experience as a sexual minority will disagree with the way I’ve chosen to interpret the call of Jesus, believing I’ve bought into a tragic, archaic ritual of self-hatred.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Self-hatred. I’ll tell you about that too. I’ll tell you how hard it is some days to look in the mirror and believe that God could have possibly said over me, as he did over all creation, “It is good.”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("But I promise my story won’t all be sadness and loneliness and struggle. I’ll tell you good things too, hopeful things, funny things, like the time I accidentally came out to my best friend during his bachelor party. I’ll tell you what it felt like the first time someone looked me in the eyes and said, “You are not a mistake.” I’ll tell you that joy and sorrow are not opposites, that my life has never been more beautiful than when it was most brokenhearted.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("If you’ll listen, I promise I’ll tell you everything, and you can decide for yourself what you want to believe about me.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("All you have to promise in return is that you’ll wait a little while before you reach your verdict about me. Wait until you’ve heard everything. Wait until you know me. And then, well . . .")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Then the rest is up to you.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8aecd796","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/07_prelude.vue
// module id = 69
// module chunks = 0